export default "__VITE_ASSET__C85eTKjA__"